import Landing from './components/Views/Question/Landing'
import Select from './components/Views/Question/Select'
import Radio from './components/Views/Question/Radio'
import MultiSelect from './components/Views/Question/MultiSelect'
import RadioSelect from './components/Views/Question/RadioSelect'

const purple = '#6B5DD9'
const blue = '#518EF8'

export default [
  {
    id: "landing",
    component: Landing,
    pageTitle: "What does it take to go to ECU?",
    question: "What does it take to go to ECU?",
    questionCategory: "",
    answers: [
      {
        text: "",
        target: "start",
      }
    ],
    shapes: {
      macaroni: { x: 56, y: 50, width: 195, height: 195, rotate: -90 },
      pie: { x: 72, y: 5, width: 322, height: 322, rotate: 0 },
      gridsquare: { x: 83, y: 22, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 100, y: 100, width: 464, height: 464, rotate: 0 },
      circle: { x: 50, y: 100, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "start",
    component: Select,
    pageTitle: "What type of application do you want to make?",
    question: "What type of application do you want to make?",
    questionCategory: "",
    answers: [
      {
        text: "Apply for an undergraduate program",
        target: "transfer"
      },
      {
        text: "Apply for a graduate program",
        target: "graduatePrograms"
      },
      {
        text: "Register for a Continuing Studies course or certificate",
        target: "continuingStudies"
      },
    ],
    answerDelay: 2000,
    shapes: {
      macaroni: { x: 77, y: 0, width: 195, height: 195, rotate: 0 },
      pie: { x: 100, y: -100, width: 322, height: 322, rotate: 0 },
      gridsquare: { x: 100, y: 100, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 78, y: 38, width: 464, height: 464, rotate: 0 },
      circle: { x: 50, y: 100, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [purple],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "transfer",
    component: Radio,
    pageTitle: "Have you taken any college or university-level courses, or completed an undergraduate degree?",
    question: "Have you taken any college or university-level courses, or completed an undergraduate degree?",
    questionCategory: "",
    answers: [
      {
        text: "Yes",
        target: "undergraduatePrograms"
      },
      {
        text: "No",
        target: "undergraduatePrograms"
      }
    ],
    answerDelay: 2600,
    shapes: {
      macaroni: { x: 83, y: 10, width: 195, height: 195, rotate: 0 },
      pie: { x: 100, y: -100, width: 322, height: 322, rotate: 0 },
      gridsquare: { x: 100, y: 100, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 38, y: 48, width: 464, height: 464, rotate: 0 },
      circle: { x: 50, y: 100, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "undergraduatePrograms",
    component: MultiSelect,
    pageTitle: "What programs are you interested in?",
    question: "What programs are you interested in?",
    questionCategory: "Undergraduate Programs",
    answers: [
      {
        text: "2D + Experimental Animation",
        target: "citizenship",
        page: "https://www.ecuad.ca/2d-experimental-animation"
      },
      {
        text: "3D + Computer Animation",
        target: "citizenship",
        page: "https://www.ecuad.ca/3d-computer-animation"
      },
      {
        text: "Ceramics",
        target: "citizenship",
        page: "https://www.ecuad.ca/ceramics"
      },
      {
        text: "Communication Design",
        target: "citizenship",
        page: "https://www.ecuad.ca/communication-design"
      },
      {
        text: "Critical + Cultural Practices",
        target: "citizenship",
        page: "https://www.ecuad.ca/crcp"
      },
      {
        text: "Drawing",
        target: "citizenship",
        page: "https://www.ecuad.ca/drawing"
      },
      {
        text: "Film + Screen Arts",
        target: "citizenship",
        page: "https://www.ecuad.ca/fmsa"
      },
      {
        text: "Illustration",
        target: "citizenship",
        page: "https://www.ecuad.ca/illustration-program-page"
      },
      {
        text: "Industrial Design",
        target: "citizenship",
        page: "https://www.ecuad.ca/industrial-design"
      },
      {
        text: "Interaction Design",
        target: "citizenship",
        page: "https://www.ecuad.ca/interaction-design"
      },
      {
        text: "New Media + Sound Arts",
        target: "citizenship",
        page: "https://www.ecuad.ca/nmsa"
      },
      {
        text: "Painting",
        target: "citizenship",
        page: "https://www.ecuad.ca/painting-program"
      },
      {
        text: "Photography",
        target: "citizenship",
        page: "https://www.ecuad.ca/photography-program"
      },
      {
        text: "Print Media",
        target: "citizenship",
        page: "https://www.ecuad.ca/print-media-program"
      },
      {
        text: "Sculpture + Expanded Practices",
        target: "citizenship",
        page: "https://www.ecuad.ca/sculpture-expanded-practices"
      },
      {
        text: "Visual Arts",
        target: "citizenship",
        page: "https://www.ecuad.ca/visual-arts"
      },
      {
        text: "I'm not sure yet",
        target: "citizenship",
        page: "https://www.ecuad.ca/admissions/explore"
      }
    ],
    answerDelay: 1600,
    shapes: {
      macaroni: { x: 100, y: 0, width: 195, height: 195, rotate: 0 },
      pie: { x: 35, y: -15, width: 322, height: 322, rotate: 90 },
      gridsquare: { x: 17, y: 49, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 100, y: 100, width: 464, height: 464, rotate: 0 },
      circle: { x: 41, y: 42, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "graduatePrograms",
    component: Select,
    pageTitle: "What programs are you interested in?",
    question: "What programs are you interested in?",
    questionCategory: "Graduate Programs",
    answers: [
      {
        text: "Master of Fine Arts",
        target: "citizenship",
        page: "https://www.ecuad.ca/academics/graduate-degrees/master-of-fine-arts"
      },
      {
        text: "Master of Design",
        target: "citizenship",
        page: "https://www.ecuad.ca/academics/graduate-degrees/master-of-design"
      },
      {
        text: "I haven't decided on a program",
        target: "citizenship",
        page: "https://www.ecuad.ca/admissions/explore"
      },
    ],
    answerDelay: 1600,
    shapes: {
      macaroni: { x: 100, y: 0, width: 195, height: 195, rotate: 0 },
      pie: { x: 35, y: -15, width: 322, height: 322, rotate: 90 },
      gridsquare: { x: 17, y: 49, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 100, y: 100, width: 464, height: 464, rotate: 0 },
      circle: { x: 41, y: 42, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "citizenship",
    component: RadioSelect,
    pageTitle: "Are you a Canadian citizen or permanent resident?",
    question: "Are you a Canadian citizen or permanent resident?",
    questionCategory: "",
    answers: [
      {
        text: "Yes",
        target: "indigenous"
      },
      {
        text: "No",
        choices: [
          "China",
          "India",
          "United States",
          "Afghanistan",
          "Albania",
          "Algeria",
          "Andorra",
          "Angola",
          "Antigua and Barbuda",
          "Argentina",
          "Armenia",
          "Australia",
          "Austria",
          "Azerbaijan",
          "The Bahamas",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bhutan",
          "Bolivia",
          "Bosnia and Herzegovina",
          "Botswana",
          "Brazil",
          "Brunei",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cabo Verde",
          "Cambodia",
          "Cameroon",
          "Central African Republic",
          "Chad",
          "Chile",
          "Colombia",
          "Comoros",
          "Congo, Democratic Republic of the",
          "Congo, Republic of the",
          "Costa Rica",
          "Côte d’Ivoire",
          "Croatia",
          "Cuba",
          "Cyprus",
          "Czech Republic",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic",
          "East Timor (Timor-Leste)",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Eswatini",
          "Ethiopia",
          "Fiji",
          "Finland",
          "France",
          "Gabon",
          "The Gambia",
          "Georgia",
          "Germany",
          "Ghana",
          "Greece",
          "Grenada",
          "Guatemala",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Honduras",
          "Hungary",
          "Iceland",
          "Indonesia",
          "Iran",
          "Iraq",
          "Ireland",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea, North",
          "Korea, South",
          "Kosovo",
          "Kuwait",
          "Kyrgyzstan",
          "Laos",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands",
          "Mauritania",
          "Mauritius",
          "Mexico",
          "Micronesia, Federated States of",
          "Moldova",
          "Monaco",
          "Mongolia",
          "Montenegro",
          "Morocco",
          "Mozambique",
          "Myanmar (Burma)",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands",
          "New Zealand",
          "Nicaragua",
          "Niger",
          "Nigeria",
          "North Macedonia",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines",
          "Poland",
          "Portugal",
          "Qatar",
          "Romania",
          "Russia",
          "Rwanda",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Slovakia",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "South Africa",
          "Spain",
          "Sri Lanka",
          "Sudan",
          "Sudan, South",
          "Suriname",
          "Sweden",
          "Switzerland",
          "Syria",
          "Taiwan",
          "Tajikistan",
          "Tanzania",
          "Thailand",
          "Togo",
          "Tonga",
          "Trinidad and Tobago",
          "Tunisia",
          "Turkey",
          "Turkmenistan",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "United Arab Emirates",
          "United Kingdom",
          "Uruguay",
          "Uzbekistan",
          "Vanuatu",
          "Vatican City",
          "Venezuela",
          "Vietnam",
          "Yemen",
          "Zambia",
          "Zimbabwe"
        ],
        target: "indigenous"
      },
      
    ],
    answerDelay: 1800,
    shapes: {
      macaroni: { x: 76, y: 49, width: 195, height: 195, rotate: 180 },
      pie: { x: 100, y: 0, width: 322, height: 322, rotate: 0 },
      gridsquare: { x: 79, y: -5, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 100, y: 100, width: 464, height: 464, rotate: 0 },
      circle: { x: 50, y: 100, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "indigenous",
    component: Radio,
    pageTitle: "Are you Indigenous (First Nations, Metis, or Inuit)?",
    question: "Are you Indigenous (First Nations, Metis, or Inuit)?",
    questionCategory: "",
    answers: [
      {
        text: "Yes",
        target: "language"
      },
      {
        text: "No",
        target: "language"
      }
    ],
    answerDelay: 1800,
    shapes: {
      macaroni: { x: 70, y: 19, width: 195, height: 195, rotate: 180 },
      pie: { x: 100, y: 0, width: 322, height: 322, rotate: 0 },
      gridsquare: { x: 29, y: 40, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 100, y: 100, width: 464, height: 464, rotate: 0 },
      circle: { x: 50, y: 100, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "language",
    component: Radio,
    pageTitle: "Is English your first language?",
    question: "Is English your first language?",
    questionCategory: "",
    answers: [
      {
        text: "Yes",
        target: "location"
      },
      {
        text: "No",
        target: "location"
      }
    ],
    answerDelay: 1400,
    shapes: {
      macaroni: { x: 32, y: 45, width: 195, height: 195, rotate: 180 },
      pie: { x: 100, y: 0, width: 322, height: 322, rotate: 0 },
      gridsquare: { x: 39, y: -25, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 100, y: 100, width: 464, height: 464, rotate: 0 },
      circle: { x: 50, y: 100, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "location",
    component: RadioSelect,
    pageTitle: "Do you currently reside in Canada?",
    question: "Do you currently reside in Canada?",
    questionCategory: "",
    answers: [
      {
        text: "Yes",
        target: "applying"
      },
      {
        text: "No",
        choices: [
          "China",
          "India",
          "United States",
          "Afghanistan",
          "Albania",
          "Algeria",
          "Andorra",
          "Angola",
          "Antigua and Barbuda",
          "Argentina",
          "Armenia",
          "Australia",
          "Austria",
          "Azerbaijan",
          "The Bahamas",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bhutan",
          "Bolivia",
          "Bosnia and Herzegovina",
          "Botswana",
          "Brazil",
          "Brunei",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cabo Verde",
          "Cambodia",
          "Cameroon",
          "Central African Republic",
          "Chad",
          "Chile",
          "Colombia",
          "Comoros",
          "Congo, Democratic Republic of the",
          "Congo, Republic of the",
          "Costa Rica",
          "Côte d’Ivoire",
          "Croatia",
          "Cuba",
          "Cyprus",
          "Czech Republic",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic",
          "East Timor (Timor-Leste)",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Eswatini",
          "Ethiopia",
          "Fiji",
          "Finland",
          "France",
          "Gabon",
          "The Gambia",
          "Georgia",
          "Germany",
          "Ghana",
          "Greece",
          "Grenada",
          "Guatemala",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Honduras",
          "Hungary",
          "Iceland",
          "Indonesia",
          "Iran",
          "Iraq",
          "Ireland",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea, North",
          "Korea, South",
          "Kosovo",
          "Kuwait",
          "Kyrgyzstan",
          "Laos",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands",
          "Mauritania",
          "Mauritius",
          "Mexico",
          "Micronesia, Federated States of",
          "Moldova",
          "Monaco",
          "Mongolia",
          "Montenegro",
          "Morocco",
          "Mozambique",
          "Myanmar (Burma)",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands",
          "New Zealand",
          "Nicaragua",
          "Niger",
          "Nigeria",
          "North Macedonia",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines",
          "Poland",
          "Portugal",
          "Qatar",
          "Romania",
          "Russia",
          "Rwanda",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Slovakia",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "South Africa",
          "Spain",
          "Sri Lanka",
          "Sudan",
          "Sudan, South",
          "Suriname",
          "Sweden",
          "Switzerland",
          "Syria",
          "Taiwan",
          "Tajikistan",
          "Tanzania",
          "Thailand",
          "Togo",
          "Tonga",
          "Trinidad and Tobago",
          "Tunisia",
          "Turkey",
          "Turkmenistan",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "United Arab Emirates",
          "United Kingdom",
          "Uruguay",
          "Uzbekistan",
          "Vanuatu",
          "Vatican City",
          "Venezuela",
          "Vietnam",
          "Yemen",
          "Zambia",
          "Zimbabwe"
        ],
        target: "applying"
      }
    ],
    answerDelay: 1600,
    shapes: {
      macaroni: { x: 100, y: 100, width: 195, height: 195, rotate: 0 },
      pie: { x: 60, y: 49, width: 322, height: 322, rotate: 0 },
      gridsquare: { x: 94, y: 20, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 100, y: 100, width: 464, height: 464, rotate: 0 },
      circle: { x: 50, y: 100, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 76, y: 7, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "applying",
    component: MultiSelect,
    pageTitle: "What information about applying to ECU do you need?",
    question: "What information about applying to ECU do you need?",
    questionCategory: "Applying to ECU",
    answers: [
      {
        text: "Application deadlines",
        target: "finances",
        page: "https://www.ecuad.ca/admissions/application-info/graduate-applications/how-to-apply"
      },
      {
        text: "Portfolio requirements",
        target: "finances",
        page: "https://www.ecuad.ca/admissions/application-info/graduate-applications/how-to-apply"
      },
      {
        text: "Academic requirements (grades)",
        target: "finances",
        page: "https://www.ecuad.ca/admissions/application-info/graduate-applications/how-to-apply"
      },
      {
        text: "Application steps",
        target: "finances",
        page: "https://www.ecuad.ca/admissions/application-info/graduate-applications/how-to-apply"
      },
      {
        text: "None of these",
        target: "finances",
        page: "https://www.ecuad.ca/admissions/application-info/graduate-applications/how-to-apply"
      }
    ],
    answerDelay: 2000,
    shapes: {
      macaroni: { x: 80, y: 5, width: 195, height: 195, rotate: 90 },
      pie: { x: 100, y: 0, width: 322, height: 322, rotate: 0 },
      gridsquare: { x: 84, y: 49, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 100, y: 100, width: 464, height: 464, rotate: 0 },
      circle: { x: 94, y: 43, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  },
  {
    id: "finances",
    component: MultiSelect,
    pageTitle: "What information about finances do you need?",
    question: "What information about finances do you need?",
    questionCategory: "Finances",
    answers: [
      {
        text: "Program costs (tuition and fees)",
        target: "checklist",
        page: "https://www.ecuad.ca/about/administration/financial-services/tuition-fees/undergraduation-tuition-and-fees"
      },
      {
        text: "Relevant funding and scholarships",
        target: "checklist",
        page: "https://www.ecuad.ca/about/administration/financial-services/tuition-fees/undergraduation-tuition-and-fees"
      },
      {
        text: "Student loans and financing",
        target: "checklist",
        page: "https://www.ecuad.ca/about/administration/financial-services/tuition-fees/undergraduation-tuition-and-fees"
      },
      {
        text: "Cost of living in Vancouver",
        target: "checklist",
        page: "https://www.ecuad.ca/about/administration/financial-services/tuition-fees/undergraduation-tuition-and-fees"
      },
      {
        text: "None of these",
        target: "checklist",
        page: "https://www.ecuad.ca/about/administration/financial-services/tuition-fees/undergraduation-tuition-and-fees"
      }
    ],
    answerDelay: 2000,
    shapes: {
      macaroni: { x: 100, y: 100, width: 195, height: 195, rotate: 0 },
      pie: { x: 66, y: 39, width: 322, height: 322, rotate: 0 },
      gridsquare: { x: 81, y: 10, width: 0, height: 0, rotate: 0 },
      gridcircle: { x: 100, y: 100, width: 464, height: 464, rotate: 0 },
      circle: { x: 50, y: 100, width: 173, height: 173, rotate: 0 },
      halfcircle: { x: 100, y: -100, width: 259, height: 518, rotate: 0 },
      square: { x: 100, y: 0, width: 167, height: 167, rotate: 0 },
    },
    primary_gradient: [],
    secondary_gradient: "",
    clip: ""
  }
]